import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const StateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ state: event.target.value }));
  };

  return (
    <TextField
      label="State"
      size="small"
      fullWidth
      value={currentVendor?.state || ''}
      onChange={handleChange}
    />
  );
};

export default StateEdit;
